'use strict';

var React = require('react');

var SvgAnalyticsTableMinor = function SvgAnalyticsTableMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-10Zm8 12h2v-6h-2v6Zm0-8h2v-2h-2v2Zm-2-2v2h-2v-2h2Zm0 4v6h-2v-6h2Zm-4 6v-6h-2v6h2Zm0-8v-2h-2v2h2Z"
  }));
};

exports.SvgAnalyticsTableMinor = SvgAnalyticsTableMinor;
